import { render } from "./DefaultSvgFile.vue?vue&type=template&id=baf5ca5c&scoped=true"
import script from "./DefaultSvgFile.vue?vue&type=script&lang=js"
export * from "./DefaultSvgFile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf5ca5c"]])

export default __exports__